import { ca } from '@cian/analytics';

import { EAnalyticsKey } from '../../types/chatHint';
import { TSingleChatV2Response } from '../../types/chatList';
import { TGoogleAnalytics } from '../../types/openedChats';

export function trackOpenNoLinksPopup() {
  ca('eventSite', {
    action: 'Open_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
  });
}
export function trackOpenForbiddenTextPopup() {
  ca('eventSite', {
    action: 'Open_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
  });
}

interface ITrackFirstMessageSentParams {
  action?: string;
  ga?: TGoogleAnalytics | null;
  response: TSingleChatV2Response;
  userId: number;
  analyticsKey: EAnalyticsKey | null;
  pageTypeSource?: string;
}

export function trackFirstMessageSent({
  action,
  ga,
  response,
  userId,
  analyticsKey,
  pageTypeSource,
}: ITrackFirstMessageSentParams) {
  const { products: gaProducts, source, sc, offersQty, mlSearchSessionGuid } = ga || {};
  //@ts-expect-error Другого способа получить информацию о странице нет
  const page = window.CianAnalytics?.service.config.page || {};

  const { offer, users } = response;

  const companion = users.find((user: { userId: number }) => user.userId !== userId);

  const products = gaProducts || [
    {
      id: offer?.id,
      offerType: offer ? 'offer' : 'agent',
      ...(offer ? {} : { extra: { recipientid: companion?.userId } }),
    },
  ];

  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: action || 'send_message',
    label: source,
    products,
    page: {
      ...page,
      extra: {
        owner_id: userId,
        questionName: analyticsKey,
        pageTypeSource,
        mlSearchSessionGuid,
      },
      offersQty,
    },
    sc,
  });
}

interface ITrackFirstMessageWithBotSentParams {
  label?: string;
  opponentId?: number | null;
  ownerId?: number | null;
  analyticsKey: EAnalyticsKey | null;
  pageTypeSource?: string;
  botId: number | null;
}

export function trackFirstMessageWithBotSent({
  label,
  ownerId,
  opponentId,
  analyticsKey,
  pageTypeSource,
  botId,
}: ITrackFirstMessageWithBotSentParams) {
  //@ts-expect-error Другого способа получить информацию о странице нет
  const page = window.CianAnalytics?.service.config.page || {};

  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: 'send_message',
    label,
    useLastProducts: true,
    page: {
      ...page,
      extra: {
        owner_id: ownerId,
        opponent_id: opponentId,
        bot_id: botId,
        questionName: analyticsKey,
        pageTypeSource,
      },
    },
  });
}
